import Seo from '../components/Seo.jsx';
import Eyebrow from '../components/ui/Eyebrow.jsx';
import Button from '../components/ui/Button.jsx';
import { MOVEMENT } from '../content/home.js';

const TRACKS = [
  'Bird population & mortality',
  'Egg production vs. target',
  'Feed consumption & cost/kg',
  'Profit trend, per flock',
  'Vaccination schedules',
  'Temperature & humidity (sensor)',
  'Ammonia levels (sensor)',
  'Water level (sensor)',
];

export default function About() {
  return (
    <>
      <Seo
        title="About"
        description="Chickrah was built from what a working poultry operation needed to see every day, not a hypothetical feature list."
        path="/about"
      />

      <section className="bg-deep pt-14 pb-12">
        <div className="wrap">
          <Eyebrow className="mb-3 !text-amber">About Chickrah</Eyebrow>
          <h1 className="mb-4 max-w-[680px] font-display text-[28px] font-bold leading-tight text-white lg:text-[38px]">
            Built on a real farm, not a whiteboard.
          </h1>
          <p className="max-w-[560px] text-[15.5px] text-mist">
            Chickrah was built directly from what a working poultry operation needed to see every
            day. We are working outward from those first farm relationships rather than guessing at
            features from a boardroom.
          </p>
        </div>
      </section>

      <section className="py-14">
        <div className="wrap grid gap-10 lg:grid-cols-3">
          {MOVEMENT.columns.map((c) => (
            <div key={c.title}>
              <h2 className="mb-2.5 font-display text-[15px] font-bold uppercase tracking-wide text-deep">
                {c.title}
              </h2>
              <p className="text-[13.5px] leading-relaxed text-muted">{c.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="pb-16">
        <div className="wrap">
          <h2 className="mb-6 font-display text-[22px] font-bold text-deep">What Chickrah tracks</h2>
          <ul className="grid gap-3 sm:grid-cols-2">
            {TRACKS.map((t) => (
              <li
                key={t}
                className="flex items-center gap-2.5 rounded-xl border border-line bg-white px-4 py-3 text-[14px] text-ink-soft"
              >
                <span className="h-2 w-2 flex-none rounded-sm bg-info" aria-hidden="true" />
                {t}
              </li>
            ))}
          </ul>

          <div className="mt-9">
            <Button to="/demo" variant="dark">
              Book a demo
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}
